import React from "react";

import "./stylesEmailNotificationPreview.css";

import IconAlert from "../../../../../../assets/icons/ic_alert.svg";
import { AppStrings } from "../../../../../../utils/constants/AppStrings";

function EmailNotificationPreview() {
  return (
    <main className="email-notification-preview-container">
      <section className="contentWrapper">
        <section className="blank">
          <header className="listtop">
            <h2 className="title">{AppStrings.BLANK}</h2>
            <button className="buttonsTextbtn">
              <span className="text">{AppStrings.EDIT_EMAIL_BODY}</span>
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/4005b7e08853790e68473f4548650cbe2726c0a6?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200"
                alt="Edit"
                className="img"
              />
            </button>
          </header>
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/a2a573192c3c9b6bcc87a4b13ec281bc1a363a00?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200"
            alt="Email preview"
            className="img2"
          />
        </section>
        <section className="sendingInfo">
          <header className="listtop">
            <h2 className="title">{AppStrings.SENDING_INFO}</h2>
            <button className="buttonsTextbtn">
              <span className="text">{AppStrings.EDIT_SENDING_INFO}</span>
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/4005b7e08853790e68473f4548650cbe2726c0a6?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200"
                alt="Edit"
                className="img"
              />
            </button>
          </header>
          <div className="div2">
            <div className="css1">
              <label className="from">{AppStrings.FROM}:</label>
              <p className="div3">-</p>
            </div>
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/455f1eb482f9ba19aad7361be2ed94bd7963d913?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200"
              alt="Divider"
              className="img3"
            />
            <div className="css2">
              <label className="subject">{AppStrings.SUBJECT}:</label>
              <p className="div4">-</p>
            </div>
          </div>
        </section>
        <aside className="notifications">
          <div className="icon">
            <img src={IconAlert} className="icons24Alert" alt="icon alert"/>
          </div>
          <div className="div5">
            <p
              className={
              "youremailbodydoesnotincludeanunsubscribelinkThisisrequiredbylawonallmarketingemailsWerecommendincludingLiquidtag"              }
            >
              {AppStrings.YOUR_EMAIL_BODY_UNSUBSCRIBE_LINK_MESSAGE}
            </p>
            <code className="setPlayerToUnsubscribedUrl">
              &#123;&#123; $set_player_to_unsubscribed_url &#125;&#125;.
            </code>
            <p className="formoreinfoseeourdocumentation">
              {AppStrings.FOR_MORE_INFO_SEE_OUR_DOCUMENTATION} <a href="#" className="documentationLink"> {AppStrings.DOCUMENTATION} </a>.
            </p>
          </div>
        </aside>
      </section>
    </main>
  );
}

export default EmailNotificationPreview;
